import React from "react";
import { ImgV2 } from "../ImgV2";
export const TwoSectionWithTitleNewCard = ({ title, items, mainIcon }) => (React.createElement("div", { className: "two-section-with-title-new-card" },
    React.createElement("div", { className: "two-section-with-title-new-card__title-wrapper" },
        React.createElement(ImgV2, { src: mainIcon, alt: title }),
        React.createElement("h4", null, title)),
    React.createElement("ul", { className: "two-section-with-title-new-card__list-wrapper" }, items && items.map((item, i) => (React.createElement("li", { key: `two-section-${i}`, className: "two-section-with-title-new-card__item" }, item))))));
